module.exports = __webpack_public_path__ + "static/media/success.1c283b20.gif";